import React, {useState} from 'react';
import MerchantInformationForm from "../../components/MerchantEnrollment/MerchantInformationForm";
import MerchantProfileForm from "../../components/MerchantEnrollment/MerchantProfileForm";
import PaymentInformationForm from "../../components/MerchantEnrollment/PaymentInformationForm";
import AdminForm from "../../components/MerchantEnrollment/AdminForm";
import MerchantConfirmation from "../../components/MerchantEnrollment/MerchantConfirmation";
import ResponsePage from "../../components/MerchantEnrollment/ResponsePage";

function MerchantFormsTemplate({handleNext, currentStep}) {

    const [payload, setPayload] = useState({
        MerchantEnrollmentInformation: {},
        MerchantEnrollmentProfile: {},
        MerchantEnrollmenPaymentInfo: {},
        MerchantEnrollmentEmployees: {},
        Additionals: {}
    });

    return (
        <>
            {
                currentStep === 6 &&
                <div className="py-4"></div>
            }
            <div className="form-template">
                {
                    currentStep !== 6 &&
                    <div className="header">Create Merchant Account</div>
                }
                {
                    currentStep === 1 &&
                    <MerchantInformationForm handleNext={handleNext} payload={payload} setPayload={setPayload}/>

                }

                {
                    currentStep === 2 &&
                    <MerchantProfileForm handleNext={handleNext} payload={payload} setPayload={setPayload}/>
                }

                {
                    currentStep === 3 &&
                    <PaymentInformationForm handleNext={handleNext} payload={payload} setPayload={setPayload}/>
                }

                {
                    currentStep === 4 &&
                    <AdminForm handleNext={handleNext} payload={payload} setPayload={setPayload}/>
                }
                {
                    currentStep === 5 &&
                    <MerchantConfirmation handleNext={handleNext} payload={payload} setPayload={setPayload}/>
                }

                {
                    currentStep === 6 &&
                    <ResponsePage
                        title="Application successfully sent"
                        description="Once the information is confirmed, you will receive an email to start adding your branches."
                        button={true}
                    />
                }
            </div>
        </>
    );
}

export default MerchantFormsTemplate;